import { Link } from "react-router-dom";
import { SrIcon } from "@/components/ui/SrIcon";
import { PHASE_LABELS } from "@/lib/offer-types";
import type { Channel } from "@/lib/chat-room/channels";

/** Brikke i hodet på en prosjektkanal: prosjektkode og fase, lenker til prosjektkortet. */
export function ProjectChannelLink({ channel }: { channel: Channel }) {
  const phase = channel.projectPhase
    ? PHASE_LABELS[channel.projectPhase as keyof typeof PHASE_LABELS] ?? channel.projectPhase
    : null;
  return (
    <Link
      to={`/prosjekter/${channel.id}`}
      className="inline-flex h-7 items-center gap-1.5 rounded-full border-[1.5px] border-[var(--sr-revemoerk)] bg-card px-2.5 text-xs font-medium text-foreground hover:bg-secondary"
    >
      <SrIcon name="folder" className="h-3.5 w-3.5" />
      {[channel.projectCode, phase].filter(Boolean).join(" · ") || "Prosjektkortet"}
    </Link>
  );
}
